import { matchPath } from "react-router-dom";

export function getActive(path: string, pathname: string) {
  return path ? !!matchPath({ path: path, end: false }, pathname) : false;
}

export function isExternalLink(path: string) {
  return path.includes("http");
}
